import * as Sentry from '@sentry/browser';
import { config } from '../config';

export const handleError = (e: Error) => {
  console.log(e);
  if (config.ENV === 'production') {
    Sentry.captureException(e);
  }
};
